export const customDarkTheme = {
    dark: true,
    colors: {
      primary: '#c13b33',
      secondary: '#D37570', 
      error: '#c13b33', 
      errorLight: '#FFD1D1',
      light: '#1E1E1E', 
      background: '#1A1A1A', 
      highlight: '#303030', 
      drawer: '#1D1F25',  
      success: '#65B34A', 
      warning: '#F0972D',
      "on-surface": "#dbdbdb", 
    }
  }
